import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex flex-col items-center justify-center p-4">
      <Link to="/" className="mb-8 flex items-center gap-3">
        <div className="w-10 h-10 bg-cyan-600 rounded-xl flex items-center justify-center">
          <span className="text-white font-bold text-lg">AR</span>
        </div>
        <span className="text-white font-bold text-2xl">AR Klima</span>
      </Link>
      <Outlet />
      <p className="mt-8 text-xs text-slate-400">
        © {new Date().getFullYear()} AR Klima · Tüm hakları saklıdır.
      </p>
    </div>
  );
};

export default AuthLayout;
